export const POST_PAGGE_SIZE = 10;

export const POST_SORT_OPTION = ['LATEST', 'HIGH_SCORE', 'LOW_SCORE'] as const;

export const CHANNEL_ID = [
  'KAKAO_MAP',
  'NAVER_MAP',
  'MODOODOC',
  'GOOGLE_MAP',
  'REVIEW_BOOST',
  'NAVER_CAFE',
  'GANGNAM_SISTER_MAP',
  'GANGNAM_SISTER_COMMUNITY',
  'BABITALK_FREETALK',
  'BABITALK_BALPOOM',
  'BABITALK_SISOOL',
  'YEOSHIN_TICKET',
  'NAVER_BLOG',
  'YOUTUBE',
  'CARROT_MARKET_STORE'
] as const;

export const POST_REPLY_FILTERS = ['ALL', 'HAS_REPLY', 'NO_REPLY'] as const;

export const POST_VIOLATIONS = ['INSULTING', 'DEFAMATORY'] as const;

export const POST_LEGAL_CARE_STATUS_FILTERS = ['NONE', 'REQUESTED', 'ING', 'COMPLETED', 'FAIL'] as const;

export const POST_LEGAL_CARE_STATUS = ['CUSTOMER_COMPLETED', 'PAYMENT_WAITING', 'LAWYER_ASSIGNING', 'LAWYER_REVIEWING', 'COMPLETED', 'REFUND_COMPLETED'] as const;

export const POST_EVULATION_TYPE = ['POSITIVE', 'NEGATIVE'] as const;

export const CHANNEL_NAMES = [
  'NAVER',
  'KAKAO',
  'MODOODOC',
  'GOOGLE',
  'REVIEW_BOOST',
  'NAVER_CAFE',
  'GANGNAM_SISTER_MAP',
  'BABITALK_FREETALK',
  'BABITALK_BALPOOM',
  'BABITALK_SISOOL',
  'YEOSHIN_TICKET',
  'NAVER_BLOG',
  'YOUTUBE',
  'CARROT_MARKET_STORE'
] as const;

export const POST_REPLY_MAX_LENGTH = 400;
